/**
 * Centralized clock synchronization using server time from SSE events.
 *
 * The offset is calculated as: serverTime (ms) - Date.now()
 * To get the "server-aligned" current time: Date.now() + offset
 */

let clockOffset = 0;

/**
 * Update the clock offset from a server-provided timestamp (Unix ms).
 */
export function updateClockOffset(serverTimeMs: number) {
  clockOffset = serverTimeMs - Date.now();
}

/**
 * Returns the current clock offset in milliseconds.
 */
export function getClockOffset(): number {
  return clockOffset;
}

/**
 * Returns the current time (ms) adjusted by the server clock offset.
 * Use this instead of Date.now() for all timer/countdown calculations.
 */
export function getSyncedNow(): number {
  return Date.now() + clockOffset;
}
